import { useState } from 'react';

import { COLLECTION_WISH_MAX, COLLECTION_WISH_MIN } from '@/services/collectionWishes';

import { useCollectionWish } from './useCollectionWish';

/**
 * «Какую коллекцию добавить?» — короткое пожелание в свободной форме.
 *
 * Текст уходит владельцу продукта и в генерацию не попадает. После
 * отправки форма сменяется благодарностью: второе пожелание можно
 * оставить, но не случайным повторным нажатием.
 */
export function CollectionWishForm() {
  const [value, setValue] = useState('');
  const wish = useCollectionWish();
  const length = value.trim().length;
  const ready = length >= COLLECTION_WISH_MIN && length <= COLLECTION_WISH_MAX;

  if (wish.data === 'ok') {
    return (
      <div role="status" className="flex flex-col items-start gap-3 rounded-card border border-border bg-surface p-5">
        <p className="text-text">Спасибо! Пожелание записано — мы читаем все.</p>
        <button
          type="button"
          onClick={() => {
            setValue('');
            wish.reset();
          }}
          className="inline-flex min-h-11 items-center text-sm text-accent hover:underline"
        >
          Предложить ещё
        </button>
      </div>
    );
  }

  return (
    <form
      className="flex flex-col gap-3 rounded-card border border-border bg-surface p-5"
      onSubmit={(event) => {
        event.preventDefault();
        if (ready) {
          wish.mutate(value);
        }
      }}
    >
      <label htmlFor="collection-wish" className="text-text-2">
        Опишите эпоху, стиль или настроение.
      </label>
      <textarea
        id="collection-wish"
        rows={3}
        maxLength={COLLECTION_WISH_MAX}
        value={value}
        placeholder="Например, «Голливуд 1950-х» или «зимняя сказка»"
        aria-describedby="collection-wish-hint"
        onChange={(event) => {
          setValue(event.target.value);
          if (wish.data || wish.isError) {
            wish.reset();
          }
        }}
        className="resize-y rounded-xl border border-border-strong bg-surface px-4 py-3 text-text placeholder:text-text-3"
      />
      <div id="collection-wish-hint" className="flex flex-wrap justify-between gap-x-4 gap-y-1 text-xs text-text-3">
        <p>Не указывайте имена, телефоны и другие личные данные.</p>
        <p className="tabular-nums">
          {length} / {COLLECTION_WISH_MAX}, минимум {COLLECTION_WISH_MIN}
        </p>
      </div>

      <button
        type="submit"
        disabled={!ready || wish.isPending}
        className="btn btn-primary w-full px-4 py-3 text-sm sm:w-auto sm:self-start"
      >
        {wish.isPending ? 'Отправляем…' : 'Отправить пожелание'}
      </button>

      {wish.data === 'limit' && (
        <p role="alert" className="text-sm text-danger">
          На сегодня пожеланий достаточно — спасибо! Возвращайтесь завтра.
        </p>
      )}
      {wish.data === 'invalid' && (
        <p role="alert" className="text-sm text-danger">
          Пожелание не сохранилось: напишите от {COLLECTION_WISH_MIN} до {COLLECTION_WISH_MAX} знаков.
        </p>
      )}
      {wish.isError && (
        <p role="alert" className="text-sm text-danger">
          {wish.error instanceof Error ? wish.error.message : 'Не удалось отправить пожелание.'}
        </p>
      )}
    </form>
  );
}
